exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._1nbNa{cursor:pointer}span._1nbNa,span._3kR9v{font-size:16px;margin:0 8px}._2sGjm{color:#777;font-style:italic}._2vkfN{background:#f3d8d8;color:#8b0000}._2oe2T{background:#f9fad2}.PdUN8{background:#d2e7fa}.IBfoN{padding:0!important}._28xgu{padding:7px;line-height:24px}._3Aiwl{padding:7px 3px;line-height:30px}._1BpjJ div{overflow-x:hidden!important}._1BpjJ div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "_1nbNa",
	"info": "_3kR9v",
	"sinSnapshot": "_2sGjm",
	"facturaCancelada": "_2vkfN",
	"conCambios": "_2oe2T",
	"conActualizaciones": "PdUN8",
	"tdClear": "IBfoN",
	"field": "_28xgu",
	"fieldAsignacion": "_3Aiwl",
	"hidden": "_1BpjJ"
};